var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column fill-height overflow-y-auto"},[_vm._t("default"),_c('v-spacer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }